import moment from 'moment';

export function getCurDateTime() {
  let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  return {
    date: moment(new Date()).format('YYYY-MM-DD'),
    week: weekArr[moment().weekday()],
    time: moment(new Date()).format('HH:mm:ss'),
  }
}